<template>
  <v-container fluid>
    <v-row justify="center">
      <v-col cols="12" md="8">
        <v-alert type="error">{{ $t('message.error.desc.systemErrorDesc') }}</v-alert>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import RedirectMixin from '@/mixins/redirect'

export default {
  name: 'error',
  components: {},
  data: () => ({}),
  computed: {
  },
  mixins: [RedirectMixin],
  methods: {},
  created: function () {}
}
</script>
